import { CheckCircleIcon } from '@heroicons/react/solid';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { APPLICATION_URL } from '../../constants';

function ListItem({ detail }) {
    return (
        <li className='flex items-center leading-tight sm:text-base md:text-xl lg:text-xl'>
            <span className='flex-shrink-0 pt-1'>
                <CheckCircleIcon className='h-6 w-6 text-avenue-blue-500' />
            </span>
            <span className='ml-2'>{detail}</span>
        </li>
    );
}

export function BeforeYouApply({ buttonUrl }) {
    const { hero, heroGradient } = useStaticQuery(graphql`
        {        
            hero: contentfulSiteImages(name: { eq: "BankGuaranteeInfoImage" }) {
                name
                imageFile {
                    localFile {
                        childImageSharp {
                            fluid(maxWidth: 800, quality: 75, srcSetBreakpoints: [400, 600, 800]) {
                                ...GatsbyImageSharpFluid
                                ...GatsbyImageSharpFluidLimitPresentationSize
                                src
                            }
                            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP], width: 1000, quality: 75)
                        }
                    }
                }
            },
            heroGradient: contentfulSiteImages(name: { eq: "BankGuaranteeInfoImageGradient" }) {
                name
                imageFile {
                    localFile {
                        childImageSharp {
                            fluid(maxWidth: 800, quality: 75, srcSetBreakpoints: [400, 600, 800]) {
                                ...GatsbyImageSharpFluid
                                ...GatsbyImageSharpFluidLimitPresentationSize
                                src
                            }
                            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP], width: 1000, quality: 75)
                        }
                    }
                }
            }            
        }
    `);

    const DetailsYouNeed = [
        'Your contact details',
        'Your business details',
        'Your beneficiary’s details',
        'Your bank guarantee purpose',
    ];

    const EligibilityCriteria = ['Your business has a valid ABN (or ACN for corporate trustees)'];

    return (
        <div className='mx-auto grid max-w-[105rem] rounded-lg border border-gray-200 bg-avenue-parchment-400 px-14 py-16 max-xl:justify-items-center xl:grid-cols-2'>
            <div className='space-y-16 xl:mt-10'>
                <h2 className='text-4xl tracking-tighter text-avenue-slate-500 md:text-5xl xl:whitespace-nowrap'>
                    What you’ll need before you apply
                </h2>

                <div className='flex flex-col gap-6 sm:flex-row lg:gap-14'>
                    <div className='space-y-5 md:min-w-[20rem] lg:min-w-[18rem]'>
                        <h3 className='text-md/5 rounded-full font-sans font-bold uppercase tracking-wider xs:tracking-widest'>
                            Details you need
                        </h3>

                        <ul className='list-none space-y-1'>
                            {DetailsYouNeed.map((detail, index) => (
                                <ListItem key={index} detail={detail} />
                            ))}
                        </ul>
                    </div>

                    <div className='space-y-5 max-w-[20rem]'>
                        <h3 className='text-md/5 rounded-full font-sans font-bold uppercase tracking-wider xs:tracking-widest'>
                            Eligibility criteria
                        </h3>

                        <ul className='list-none space-y-1'>
                            {EligibilityCriteria.map((detail, index) => (
                                <ListItem key={index} detail={detail} />
                            ))}
                        </ul>
                    </div>
                </div>
                <div className='flex flex-col gap-6 sm:flex-row lg:gap-14'>
                    <a
                      href={buttonUrl || APPLICATION_URL}
                      id='apply-now-btn'
                      type='button'
                      className='block w-max justify-center whitespace-nowrap rounded-md bg-avenue-orange-500 px-8 py-4 text-center text-lg font-bold tracking-normal text-white shadow-lg transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-110 max-md:px-5'
                      target='_self'
                      rel='noreferrer'
                    >
                        Apply now
                        <span className='tracking-normal text-white'> →</span>
                    </a>
                </div>

            </div>

            <div className='hidden xl:block'>
                <GatsbyImage
                    loading='lazy'
                    image={heroGradient?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                    alt='Engineer with a laptop'
                    className='max-w-[700px] max-xl:mt-10 max-xl:justify-self-center max-xl:w-full max-xl:object-cover [&>picture>img]:!object-contain'
                />
            </div>
            <div className='block xl:hidden'>
                <GatsbyImage
                  loading='lazy'
                  image={hero?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                  alt='Engineer with a laptop'
                  className='max-w-[700px] max-xl:mt-10 max-xl:justify-self-center max-xl:w-full max-xl:object-cover [&>picture>img]:!object-contain'
                />
            </div>
        </div>
    );
}




